/**
 * NAP API
 * REST-Api für das nap Tool.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: marius.junak@conergos.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TypedForm } from '@bo-client/shared/forms/generic-forms/typedForm.type';

export interface ContactDataDto {
  partnerId?: any;
  fax?: any;

  city?: string;
  company?: string;
  companyAddition?: string;
  contactType?: ContactDataDto.ContactTypeEnum;
  country?: string;
  department?: string;
  firstName?: string;
  lastName?: string;
  latitude?: number;
  longitude?: number;
  mail?: string;
  mobile?: string;
  phone?: string;
  salutation?: string;
  street?: string;
  streetNo?: string;
  streetNoAddition?: string;
  zipCode?: string;
}
export namespace ContactDataDto {
  export function empty(): ContactDataDto {
    return {
      city: null,
      company: null,
      companyAddition: null,
      firstName: null,
      lastName: null,
      mail: null,
      phone: null,
      salutation: null,
      street: null,
      streetNo: null,
      zipCode: null
    };
  }
  export type ContactTypeEnum = 'Person' | 'Company';
  export const ContactTypeEnum = {
    Person: 'Person' as ContactTypeEnum,
    Company: 'Company' as ContactTypeEnum
  };
  export type SalutationEnum = 'Herr' | 'Frau';
  export const SalutationEnum = {
    Herr: 'Herr' as SalutationEnum,
    Frau: 'Frau' as SalutationEnum
  };
}

export type ContactDataForm = TypedForm<
  Pick<
    ContactDataDto,
    | 'city'
    | 'company'
    | 'companyAddition'
    | 'streetNo'
    | 'street'
    | 'firstName'
    | 'lastName'
    | 'mail'
    | 'phone'
    | 'salutation'
    | 'zipCode'
  >
>;

export type InvoiceContactForm = ContactDataForm;
